import React from "react";
import { Grid, Paper, Stack, Typography, Checkbox, FormControlLabel } from "@mui/material";
import { getCookie, setCookie } from "utils/commonFunc";

const ItsQuestionPaper = () => {
    const [stopWatchingToday, setStopWatchingToday] = React.useState(getCookie("stopWatchingToday") === 'true');

    const onChangeHandler = (e) => {
        const value = e.target.checked;
        setCookie("stopWatchingToday", value, 1);
        setStopWatchingToday(value);
    }
    return (
        <Paper sx={{ width: '50vm', p: 4 }}>
            <Typography variant="h6" gutterBottom>교통 통계 조회를 위한 도로/교차로 선택 페이지입니다.</Typography>
            <Typography variant="body1" gutterBottom>1. 우측 상단 영역에서 평균속도를 선택하거나 교통량을 선택하세요.</Typography>
            <Typography variant="body1" gutterBottom>2. 우측 지도 영역에서 평균속도에서는 도로를 선택, 교통량에서는 교차로를 선택할 수 있습니다.</Typography>
            <Typography variant="body1" gutterBottom>3. 좌측 목록을 활용하여 도로 위치나 교차로 위치를 찾을 수 있습니다.</Typography>
            <Grid sx={{}} container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Paper variant="outlined" sx={{ p: 1 }}>
                        <img style={{ maxWidth: '100%', maxHeight: '100%', width: 'auto', height: 'auto', verticalAlign: 'bottom' }} 
                        src='/images/roadTraffic/question2.png' alt='left' />
                    </Paper>
                </Grid>
                <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <Paper variant="outlined" sx={{ p: 1 }}>
                        <img style={{ maxWidth: '100%', maxHeight: '100%', width: 'auto', height: 'auto', display: 'block' }} 
                        src='/images/roadTraffic/question1.png' alt='left' />
                    </Paper>
                </Grid>
            </Grid>
            <Stack direction="row"
                justifyContent="flex-end"
                alignItems="center">
                <FormControlLabel control={<Checkbox 
                checked={stopWatchingToday}
                onChange={onChangeHandler}
                inputProps={{ 'aria-label': 'controlled' }}
                />} label="오늘 하루 그만 보기" />
            </Stack>
        </Paper>
    )
}

export default ItsQuestionPaper